/** 导出api */
import { axiosPostDownload } from "@/utils/request";
/**
 * 导出数据
 * @param data
 */
export const exportData = (data) => {
  axiosPostDownload({
    url: "/commonExportExcel/exportExcelByRecord",
    data: data,
  });
};

// 导出所有数据
export const exportAllData = (data) => {
  axiosPostDownload({
    url: "/commonExportExcel/exportExcelByUrl",
    data: data,
  });
};
